<template>
<div class="container-fluid px-0 stepsBar">
    <ul class="nav nav-tabs customTab justify-content-center border-top" id="" role="tablist">
        <li class="nav-item" @click="tabfor='Information'">
            <a class="nav-link rounded-0 active"  id="info-tab" data-toggle="tab" href="#info" role="tab"
            aria-controls="info" aria-selected="true">Information</a>
        </li>
        <li class="nav-item" @click="tabfor='Orders'">
            <a class="nav-link rounded-0 "  id="orders-tab" data-toggle="tab" href="#orders" role="tab"
            aria-controls="orders" aria-selected="false">Orders Management</a>
        </li>
    </ul>
    <div class="tab-content bgGray" id="myTabContent">
        <br>
        <br>
        <div class="tab-pane fade show active" id="info" role="tabpanel" aria-labelledby="info-tab">
            <Userinfo :filtertab.sync="tabfor"/>
        </div>
        <div class="tab-pane fade  orderAccordtion" id="orders" role="tabpanel"
            aria-labelledby="orders-tab">
            <UserOrder :filtertab.sync="tabfor"/>
        </div>
    </div>
</div>
</template>

<script>
    import Userinfo from './UserInfo.vue'
    import UserOrder from './UserOrder.vue'
    export default {
        name: "User-account",
        components: {
            Userinfo,
            UserOrder
        },
        data() {
            return {
                tabfor:''
            }
        },
        watch: {},
        methods: {
            async switch_tab() {

           },

        },
        async mounted() {
            this.tabfor="Information";

            if (this.$route.hash) {
                if (this.$route.hash =='#order_mngt') {
                    this.tabfor = 'Orders';
                    $('a[href="#orders"]').trigger('click');
                }
            }

            $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
                var tht = $(this);
                 $('a[data-toggle="tab"]').removeClass('active');
                  tht.addClass('active');
            });
        },
        async created() {

        },
        filters: {

        },
        computed: {

        },

    }
</script>
